export default "__VITE_ASSET__1897ab62__"